import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './lang/config'
import store from './store/config'
import vuetify from './plugins/vuetify'
import eventBus from './plugins/events'
import formatters from './plugins/formatters'
import helper from './mixins/helpers'
import api from './mixins/api_services'
import constants from './mixins/constants'
import VueCookie from 'vue-cookie'
import axios from 'axios'
import Sortable from 'sortablejs'
import VueSignaturePad from 'vue-signature-pad'
import VueHighcharts from 'vue-highcharts'
import Highcharts from 'highcharts'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import exportingInit from 'highcharts/modules/exporting'
exportingInit(Highcharts)

let filters = {
  dateFormat: helper.methods.$_filterDate,
  dateTimeFormat: helper.methods.$_filterDateTime,
  replaceDotWithComma: helper.methods.$_replaceDotWithComma,
  replaceDotWithCommaNotFixed: helper.methods.$_replaceDotWithCommaNotFixed,
  replaceDotWithCommaIfHasDecimal: helper.methods.$_replaceDotWithCommaIfHasDecimal,
  absoluteNumber: helper.methods.$_absoluteNumber,
  replaceCommaWithDot: helper.methods.$_replaceCommaWithDot,
  thousandSeparator: helper.methods.$_thousandSeparator
}
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.directive('sortable', {
  inserted: function (el, binding) {
    // eslint-disable-next-line
    new Sortable(el, binding.value || {})
  }
})
let mixins = { constants, api, helper }
Object.keys(mixins).forEach(key => {
  Vue.mixin(mixins[key])
})

let plugins = { formatters, VueCookie, eventBus }
Object.keys(plugins).forEach(key => {
  Vue.use(plugins[key])
})

Vue.use(CKEditor)
Vue.use(VueSignaturePad)
Vue.use(VueHighcharts, { Highcharts })

Vue.config.productionTip = false
axios.defaults.imageURL = process.env.VUE_APP_IMAGE_URL
axios.defaults.baseURL = process.env.VUE_APP_URL
axios.defaults.headers.common = {
  'Authorization': `Bearer ${VueCookie.get('kilab_token')}`,
  'x-web-version': process.env.VUE_APP_VERSION
}

Vue.config.warnHandler = function (msg, vm, trace) {
  if (msg !== 'Invalid prop: custom validator check failed for prop "selectionType".') {
    const hasConsole = typeof console !== 'undefined'
    if (hasConsole && !Vue.config.silent) {
      console.error(`[Vue warn]: ${msg}${trace}`)
    }
  }
}

new Vue({
  i18n,
  router,
  eventBus,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
